export default "__VITE_ASSET__IamYPMBS__"